"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var notification_1 = __importDefault(require("../../helpers/notification"));
var usePromise_1 = __importDefault(require("../../hooks/usePromise"));
var ButtonDelete_1 = __importDefault(require("../ButtonDelete"));
var ButtonSave_1 = __importDefault(require("../ButtonSave"));
var Widget_1 = __importDefault(require("../Widget"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Form_1 = __importDefault(require("../Form"));
var FormSubmitButton_1 = __importDefault(require("../FormSubmitButton"));
var Row_1 = __importDefault(require("../Row"));
var DataGrid_1 = __importDefault(require("../DataGrid"));
var CrudGrid = function (props) {
    var getAllItems = props.getAllItems, updateItem = props.updateItem, deleteItem = props.deleteItem, createItem = props.createItem, rowKey = props.rowKey, title = props.title, createForm = props.createForm, createInitialValues = props.createInitialValues, gridOptions = props.gridOptions;
    var _a = react_1.useState(), createdItem = _a[0], setCreatedItem = _a[1];
    var _b = react_1.useState([]), updatedItems = _b[0], setUpdatedItems = _b[1];
    var _c = react_1.useState(), gridApi = _c[0], setGridApi = _c[1];
    var data = usePromise_1.default(getAllItems, [createdItem], [])[0];
    var getRowKey = typeof rowKey === 'string' ? function (item) { return item[rowKey]; } : rowKey;
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        var selectedRows, ok, deletedKeys_1, newUpdatedItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!gridApi) return [3, 3];
                    selectedRows = gridApi.getSelectedRows();
                    if (!(selectedRows.length === 0)) return [3, 1];
                    notification_1.default.warn('No items to delete...');
                    return [3, 3];
                case 1: return [4, deleteItem(selectedRows)];
                case 2:
                    ok = _a.sent();
                    if (ok) {
                        notification_1.default.success(JSON.stringify(selectedRows.map(getRowKey)), 'Deleting Items');
                        gridApi.updateRowData({ remove: selectedRows });
                        deletedKeys_1 = {};
                        selectedRows.forEach(function (item) {
                            deletedKeys_1[getRowKey(item)] = true;
                        });
                        newUpdatedItems = updatedItems.filter(function (item) { return !deletedKeys_1[getRowKey(item)]; });
                        setUpdatedItems(newUpdatedItems);
                    }
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var handleUpdate = function () { return __awaiter(_this, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(updatedItems.length === 0)) return [3, 1];
                    notification_1.default.warn('No items to save...');
                    return [3, 3];
                case 1: return [4, updateItem(updatedItems)];
                case 2:
                    ok = _a.sent();
                    if (ok) {
                        notification_1.default.success(JSON.stringify(updatedItems.map(getRowKey)), 'Updating Items');
                        setUpdatedItems([]);
                    }
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var handleCreate = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var newItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createItem) return [3, 2];
                    return [4, createItem(item)];
                case 1:
                    newItem = _a.sent();
                    setCreatedItem(newItem);
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var onChangeGrid = function (e) {
        var itemKey = getRowKey(e.data);
        if (itemKey) {
            var filteredItems = updatedItems.filter(function (item) { return getRowKey(item) !== itemKey; });
            filteredItems.push(e.data);
            setUpdatedItems(filteredItems);
        }
    };
    var onGridReady = function (event) {
        setGridApi(event.api);
    };
    return (react_1.default.createElement(Widget_1.default, { title: react_1.default.createElement(FormatText_1.default, { id: title || 'Data', uppercase: true }), actions: [react_1.default.createElement(ButtonSave_1.default, { onClick: handleUpdate }), react_1.default.createElement(ButtonDelete_1.default, { onClick: handleDelete })] },
        createForm && (react_1.default.createElement(Row_1.default, null,
            react_1.default.createElement(Form_1.default, { onSubmit: handleCreate, initialValues: createInitialValues, actions: [react_1.default.createElement(FormSubmitButton_1.default, null)] }, createForm))),
        react_1.default.createElement(Row_1.default, null,
            react_1.default.createElement("div", { className: "ag-theme-balham", style: {
                    width: '100%',
                    height: '420px',
                } },
                react_1.default.createElement(DataGrid_1.default, __assign({}, gridOptions, { onGridReady: onGridReady, onCellValueChanged: onChangeGrid, rowData: data }))))));
};
exports.default = CrudGrid;
